import React, { useEffect, useRef } from 'react';

interface AdNativeBannerProps {
  className?: string;
}

const AdNativeBanner: React.FC<AdNativeBannerProps> = ({ className }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isScriptInjected = useRef(false);

  useEffect(() => {
    if (isScriptInjected.current) return;
    
    // Create and inject the script
    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-cfasync', 'false');
    script.src = '//resideour.com/0116f148c7d39834aacc50f2f9827e53/invoke.js';
    
    document.head.appendChild(script);
    isScriptInjected.current = true;
    
    return () => {
      const scriptElement = document.querySelector('script[src="//resideour.com/0116f148c7d39834aacc50f2f9827e53/invoke.js"]');
      if (scriptElement && scriptElement.parentNode) {
        scriptElement.parentNode.removeChild(scriptElement);
      }
      isScriptInjected.current = false;
    };
  }, []);

  return (
    <div className={`w-full ${className || ''}`}>
      <div id="container-0116f148c7d39834aacc50f2f9827e53" className="mx-auto" style={{ aspectRatio: '4/1' }} />
    </div>
  );
};

export default AdNativeBanner;